import {
  Box,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material'
import { NavBar } from './Navigation'
import { useComponentSizeAndPosition } from '../shared/utils'
import { DVD } from './DVD'
import { LoadingPicture } from '../shared/LoadingPicture'

export function Schedule() {
  const isMobile = window.innerWidth < 768

  return isMobile ? <ScheduleMobile /> : <ScheduleDesktop />
}

function FormattedTableCell(props: { children: React.ReactNode }) {
  return (
    <TableCell
      sx={{
        verticalAlign: 'top',
        padding: '3px 4px',
        width: '75px',
        borderBottom: 'none',
        fontWeight: 'bold',
        fontSize: '13px',
      }}
    >
      {props.children}
    </TableCell>
  )
}

function FormattedTableCellDesktop(props: { children: React.ReactNode }) {
  return (
    <TableCell
      sx={{
        verticalAlign: 'top',
        padding: '12px 8px',
        width: '75px',
        borderBottom: 'none',
        fontWeight: 'bold',
      }}
    >
      {props.children}
    </TableCell>
  )
}

function ScheduleMobile() {
  const { boxRef, width, height } = useComponentSizeAndPosition()

  return (
    <Box
      ref={boxRef}
      sx={{
        width: '100vw',
        height: '100vdh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {width && height && (
        <DVD
          containerHeight={height}
          containerWidth={width}
          initialX={70}
          initialY={height - 80}
          radius={100}
          text="Big yellow button"
        />
      )}
      <Box
        sx={{
          padding: '10px',
          bottom: 0,
          width: '100%',
          zIndex: 1,
          backgroundColor: 'rgba(255, 255, 255, 1.0)',
        }}
      >
        <NavBar direction="row" />
      </Box>
      <Box
        sx={{
          zIndex: 1,
          padding: '10px',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            marginTop: '30px',
            backgroundColor: 'rgba(238, 238, 238, 1.0)',
            border: '1px solid black',
            padding: '20px',

            width: '310px',
            rotate: '7deg',
          }}
        >
          <TableContainer>
            <Table>
              <TableBody>
                <TableRow>
                  <FormattedTableCell>Fri 05</FormattedTableCell>
                  <FormattedTableCell>3:00 PM</FormattedTableCell>
                  <FormattedTableCell>Hotel Check-In</FormattedTableCell>
                  <FormattedTableCell>
                    Scribner's Catskill Lodge
                  </FormattedTableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ borderBottom: 'none' }} />
                  <FormattedTableCell>5:00 PM</FormattedTableCell>
                  <FormattedTableCell>Garden Cocktail Party</FormattedTableCell>
                  <FormattedTableCell>Scribner's Garden</FormattedTableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <Box
          sx={{
            marginTop: '50px',
            backgroundColor: 'rgba(238, 238, 238, 1.0)',
            border: '1px solid black',
            padding: '10px',

            width: '310px',
            rotate: '-7deg',
          }}
        >
          <TableContainer>
            <Table>
              <TableBody>
                <TableRow>
                  <FormattedTableCell>Sat 06</FormattedTableCell>
                  <FormattedTableCell>3:00 PM</FormattedTableCell>
                  <FormattedTableCell>Shuttle Arrives</FormattedTableCell>
                  <FormattedTableCell>
                    Scribner's Catskill Lodge
                  </FormattedTableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ borderBottom: 'none' }} />
                  <FormattedTableCell>3:30 PM</FormattedTableCell>
                  <FormattedTableCell>Shuttle Departs</FormattedTableCell>
                  <FormattedTableCell>
                    Scribner's Catskill Lodge
                  </FormattedTableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ borderBottom: 'none' }} />
                  <FormattedTableCell>4:30 PM</FormattedTableCell>
                  <FormattedTableCell>Ceremony</FormattedTableCell>
                  <FormattedTableCell>Hayfield</FormattedTableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ borderBottom: 'none' }} />
                  <FormattedTableCell>5:00 PM</FormattedTableCell>
                  <FormattedTableCell>Cocktail Hour</FormattedTableCell>
                  <FormattedTableCell>Hayfield</FormattedTableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ borderBottom: 'none' }} />
                  <FormattedTableCell>5:30 PM</FormattedTableCell>
                  <FormattedTableCell>Reception</FormattedTableCell>
                  <FormattedTableCell>Hayfield</FormattedTableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ borderBottom: 'none' }} />
                  <FormattedTableCell>10:00 PM</FormattedTableCell>
                  <FormattedTableCell>
                    Shuttle Departs Back to Scribner’s
                  </FormattedTableCell>
                  <FormattedTableCell>Hayfield</FormattedTableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>

      {/* Background Image */}

      <Box
        sx={{
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          position: 'absolute',
          zIndex: 0,
          backgroundImage:
            'url(https://jasonandfriends-prod-pictures-bucket.s3.us-east-1.amazonaws.com/processed/wedding_schedule.jpg/medium_wedding_schedule.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      />
    </Box>
  )
}

function ScheduleDesktop() {
  const { width, height, boxRef } = useComponentSizeAndPosition()

  return (
    <Box ref={boxRef} sx={{ position: 'relative' }}>
      {width && height && (
        <DVD
          containerHeight={height}
          containerWidth={width}
          initialX={width - 150}
          initialY={height - 200}
          radius={100}
          text="Big yellow button"
        />
      )}
      <Box sx={{ padding: '10px' }}>
        <NavBar direction="row" />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ position: 'relative', width: '1100px' }}>
          <Box
            sx={{
              position: 'absolute',
              top: '15%',
              left: '10%',
              zIndex: 1,
              backgroundColor: 'rgba(238, 238, 238, 1.0)',
              border: '1px solid black',
              padding: '20px',

              width: '800px',
              rotate: '-7deg',
            }}
          >
            <Box>
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <FormattedTableCellDesktop>
                        Fri 05
                      </FormattedTableCellDesktop>
                      <FormattedTableCellDesktop>
                        3:00 PM
                      </FormattedTableCellDesktop>
                      <FormattedTableCellDesktop>
                        Hotel Check-In
                      </FormattedTableCellDesktop>
                      <FormattedTableCellDesktop>
                        Scribner's Catskill Lodge
                      </FormattedTableCellDesktop>
                    </TableRow>
                    <TableRow sx={{ borderBottom: '1px solid black' }}>
                      <TableCell sx={{ borderBottom: 'none' }} />
                      <FormattedTableCellDesktop>
                        5:00 PM
                      </FormattedTableCellDesktop>
                      <FormattedTableCellDesktop>
                        Garden Cocktail Party
                      </FormattedTableCellDesktop>
                      <FormattedTableCellDesktop>
                        Scribner's Garden
                      </FormattedTableCellDesktop>
                    </TableRow>
                    <Box sx={{ marginTop: '15px' }}></Box>
                    <TableRow>
                      <FormattedTableCellDesktop>
                        Sat 06
                      </FormattedTableCellDesktop>
                      <FormattedTableCellDesktop>
                        3:00 PM
                      </FormattedTableCellDesktop>
                      <FormattedTableCellDesktop>
                        Shuttle Arrives
                      </FormattedTableCellDesktop>
                      <FormattedTableCellDesktop>
                        Scribner's Catskill Lodge
                      </FormattedTableCellDesktop>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ borderBottom: 'none' }} />
                      <FormattedTableCellDesktop>
                        3:30 PM
                      </FormattedTableCellDesktop>
                      <FormattedTableCellDesktop>
                        Shuttle Departs
                      </FormattedTableCellDesktop>
                      <FormattedTableCellDesktop>
                        Scribner's Catskill Lodge
                      </FormattedTableCellDesktop>
                    </TableRow>

                    <TableRow>
                      <TableCell sx={{ borderBottom: 'none' }} />
                      <FormattedTableCellDesktop>
                        4:30 PM
                      </FormattedTableCellDesktop>
                      <FormattedTableCellDesktop>
                        Ceremony
                      </FormattedTableCellDesktop>
                      <FormattedTableCellDesktop>
                        Hayfield
                      </FormattedTableCellDesktop>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ borderBottom: 'none' }} />
                      <FormattedTableCellDesktop>
                        5:00 PM
                      </FormattedTableCellDesktop>
                      <FormattedTableCellDesktop>
                        Cocktail Hour
                      </FormattedTableCellDesktop>
                      <FormattedTableCellDesktop>
                        Hayfield
                      </FormattedTableCellDesktop>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ borderBottom: 'none' }} />
                      <FormattedTableCellDesktop>
                        5:30 PM
                      </FormattedTableCellDesktop>
                      <FormattedTableCellDesktop>
                        Reception
                      </FormattedTableCellDesktop>
                      <FormattedTableCellDesktop>
                        Hayfield
                      </FormattedTableCellDesktop>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ borderBottom: 'none' }} />
                      <FormattedTableCellDesktop>
                        10:00 PM
                      </FormattedTableCellDesktop>
                      <FormattedTableCellDesktop>
                        Shuttle Departs Back to Scribner’s
                      </FormattedTableCellDesktop>
                      <FormattedTableCellDesktop>
                        Hayfield
                      </FormattedTableCellDesktop>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>

          {/* Image */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <LoadingPicture
              imageId="wedding_schedule.jpg"
              size="medium"
              style={{
                height: 'calc(100vh - 100px)',
                width: '550px',

                objectFit: 'cover',
                marginRight: '30px',
              }}
              stage="prod"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
